import { Injectable } from '@angular/core';
import { AppSettingsService } from './app-settings/app-settings.service';
import { SearchResponse } from '../shared/models/domain/search-response';

@Injectable({
  providedIn: 'root'
})
export class DatalayerService {
  constructor(private appSettingsService: AppSettingsService) { }

  setDatalayer(response: SearchResponse) {
    try {
      const dataLayer = window?.['dataLayer']?.find?.((item) => item.event === 'shoppingDataReady');
      if (!dataLayer) return;

      const { loyalty } = response || {};

      dataLayer.shopping.pageview_id = this.appSettingsService.getPageViewId();

      if (this.appSettingsService.getIsLogged()) {
        const availablePoints = loyalty?.availablePoints || 0;
        dataLayer.shopping.has_loyalty_points = availablePoints > 0;
        dataLayer.shopping.loyalty_tier = loyalty?.tierCode || undefined;
        dataLayer.shopping.loyalty_balance_range = this.getRangeLoyaltyPoint(availablePoints);
      }
    } catch (error) {
      console.error('Error en setDatalayer:', error);
    }
  }

  getRangeLoyaltyPoint(points: number): string | undefined {
    const ranges = [
      { min: 1, max: 1000, label: '1-1000' },
      { min: 1001, max: 5000, label: '1001-5000' },
      { min: 5001, max: 10000, label: '5001-10000' },
      { min: 10001, max: 50000, label: '10001-50000' },
      { min: 50001, max: 100000, label: '50001-100000' },
      { min: 100001, max: 500000, label: '100001-500000' },
      { min: 500001, max: 1000000, label: '500001-1000000' },
    ];

    if (points <= 0) return undefined;

    const range = ranges.find(r => points >= r.min && points <= r.max);
    return range ? range.label : '+1000001';
  }

}
